module.exports = __webpack_public_path__ + "media/organizations/mdr-dd3982d3.svg";